// extracted by mini-css-extract-plugin
export default {"arrowButton":"Carousel_arrowButton__-ZJuY"};